// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tO0spE {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.qgZoR5 {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.j9OyGA {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.ZqKxJi {
  padding: var(--spacing-3) var(--spacing-3) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.RTsvAE {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.CxeNn1 {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: calc(-1 * var(--spacing-0-5));
}

.CxeNn1 img {
  width: 16px;
  height: 16px;
}

.CyGjUO {
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.TjLU8z {
  margin-bottom: var(--spacing-3);
}

.A2_YXU {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin: 0;
}

.oJjtxd {
  color: var(--text-primary-medium);
  font-weight: var(--font-weight-semibold);
}

.AoRyIh {
  margin-bottom: var(--spacing-3);
  padding: var(--spacing-2) !important;
}

.b3U9Rl {
  display: flex;
  gap: var(--spacing-2);
  align-items: center;
  flex-wrap: wrap;
}

.AEbXvD {
  flex: 1;
}

.WrybZr {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  white-space: nowrap;
}

.C4Q4ke {
  background-color: var(--surface-error-medium);
  color: var(--text-neutral-white);
  border-radius: var(--radius-full);
  padding: 2px var(--spacing-1);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  margin-left: var(--spacing-1);
}

._tQNH0 {
  display: flex;
  flex-direction: column;
}

.PGKDs3 {
  padding: var(--spacing-2) !important;
}

.jdsaIZ {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.Fqkk48 {
  flex: 1;
}

.y5Acmy {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  margin-bottom: var(--spacing-1);
}

.xw9EX_ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.kIhI1A {
  display: inline-flex;
  align-items: center;
}

.vLv_Kp {
  margin-bottom: var(--spacing-1-5);
}

.FqvEUy {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin: 4px 0;
}

.hzjdHL {
  display: flex;
  gap: var(--spacing-2);
  align-items: center;
  flex-wrap: wrap;
}

.pe2t1H {
  display: flex;
  align-items: center;
  gap: var(--spacing-0-5);
  border-radius: var(--radius-full);
  padding: 4px var(--spacing-1);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
}

.h3yKZE {
  background-color: var(--surface-success-subtle);
  color: var(--text-success-strong);
}

.t7jmQH {
  background-color: var(--surface-warning-subtle);
  color: var(--text-warning-strong);
}

.ie2KvT {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  color: var(--text-neutral-stronger);
}

.ZqUPh5 {
  background: none;
  border: none;
  padding: var(--spacing-1);
  cursor: pointer;
  border-radius: var(--radius-s);
  color: var(--icon-neutral-stronger);
  transition: background-color 0.2s ease;
}

.ZqUPh5:hover {
  background-color: var(--surface-neutral-subtle);
}

/* Feedback states */
.b_HZYm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: var(--spacing-4);
  text-align: center;
}

.AbVeOm {
  background: rgba(214, 64, 0, 0.1);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-3);
}

.Mo5Kji {
  width: 72px;
  height: 72px;
  color: var(--icon-error-medium);
  margin-bottom: var(--spacing-3);
}

.xp1HA4 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: 0;
}

.bAnoO4 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin-bottom: 0;
}

.oBMiRK {
  margin-top: var(--spacing-3);
}

/* Empty state */
.eIpzS8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: var(--spacing-4);
  text-align: center;
}

.Qzpvsf {
  width: 72px;
  height: 72px;
  color: var(--icon-neutral-stronger);
  margin-bottom: var(--spacing-3);
}

.gv0sya {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: 0;
}

.nNEmk6 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin-bottom: var(--spacing-3);
  max-width: 300px;
}

.m_I21B {
  margin-top: var(--spacing-1);
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .qgZoR5 {
    max-width: 100vw;
  }

  .b3U9Rl {
    flex-direction: column;
    align-items: stretch;
  }

  .AEbXvD {
    min-width: auto;
  }

  .hzjdHL {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-1);
  }
}

/* New minimal beneficiary item styles */
.Yf8kLO {
  padding: var(--spacing-3) 0;
  border-bottom: 1px solid var(--bs-gray-200);
  transition: background-color 0.2s ease;
}

.Yf8kLO:hover {
  background-color: var(--bs-gray-50);
}

.RlFcrg {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.zN6EBg {
  flex: 1;
}

.AtivFy {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  margin: 0 0 var(--spacing-0-5) 0;
}

.VEnKHd {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  margin: 0 0 0 var(--spacing-2);
}

.uFVuRc {
  display: inline-block;
  width: 1px;
  height: 8px;
  margin-left: var(--spacing-1);
  vertical-align: middle;
  background-color: var(--stroke-neutral-subtle);
}

.p5ZBTa {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  margin-top: var(--spacing-0-5);
}

.EpR4JR {
  width: 20px;
  height: 16px;
  flex-shrink: 0;
}

.mlIIFK {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
}

.iaTkd2 {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--icon-neutral-medium);
}

.grkYTG {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-medium);
}

/* Collaborators (emissor flow) — alinhado ao Figma usando tokens do design system.
   Label/Medium semibold (14px) no nome; Label/Small regular (12px) nos detalhes;
   texto escuro neutral[800], "Não possui cartão" neutral[600], gaps de 8px (spacing-1). */
.lqn9tG .Yf8kLO {
  padding: var(--spacing-2) 0;
  border-bottom-color: var(--stroke-neutral-subtle);
}

.lqn9tG .Yf8kLO:hover {
  background-color: transparent;
}

.lqn9tG .xw9EX_ {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: normal;
}

.lqn9tG .kIhI1A img {
  width: 12px;
  height: 12px;
}

.lqn9tG .AtivFy {
  margin-bottom: 0;
  line-height: normal;
  color: var(--text-neutral-dark);
}

.lqn9tG .VEnKHd {
  margin-left: var(--spacing-1);
  color: var(--text-neutral-dark);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/BeneficiariesPage.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,8BAA8B;EAC9B,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;AACF;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;0FAE0F;AAC1F;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-3) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: calc(-1 * var(--spacing-0-5));\n}\n\n.backButton img {\n  width: 16px;\n  height: 16px;\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.headerSection {\n  margin-bottom: var(--spacing-3);\n}\n\n.summaryText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n}\n\n.newEmployeesText {\n  color: var(--text-primary-medium);\n  font-weight: var(--font-weight-semibold);\n}\n\n.filtersCard {\n  margin-bottom: var(--spacing-3);\n  padding: var(--spacing-2) !important;\n}\n\n.filtersContainer {\n  display: flex;\n  gap: var(--spacing-2);\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.searchContainer {\n  flex: 1;\n}\n\n.filterButton {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  white-space: nowrap;\n}\n\n.badge {\n  background-color: var(--surface-error-medium);\n  color: var(--text-neutral-white);\n  border-radius: var(--radius-full);\n  padding: 2px var(--spacing-1);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  margin-left: var(--spacing-1);\n}\n\n.beneficiariesList {\n  display: flex;\n  flex-direction: column;\n}\n\n.beneficiaryCard {\n  padding: var(--spacing-2) !important;\n}\n\n.beneficiaryHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.beneficiaryInfo {\n  flex: 1;\n}\n\n.beneficiaryNameRow {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  margin-bottom: var(--spacing-1);\n}\n\n.beneficiaryName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.detailsTooltip {\n  display: inline-flex;\n  align-items: center;\n}\n\n.beneficiaryDetails {\n  margin-bottom: var(--spacing-1-5);\n}\n\n.beneficiaryDetail {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin: 4px 0;\n}\n\n.beneficiaryFooter {\n  display: flex;\n  gap: var(--spacing-2);\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.cardStatus {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n  border-radius: var(--radius-full);\n  padding: 4px var(--spacing-1);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n}\n\n.cardIssued {\n  background-color: var(--surface-success-subtle);\n  color: var(--text-success-strong);\n}\n\n.cardNotIssued {\n  background-color: var(--surface-warning-subtle);\n  color: var(--text-warning-strong);\n}\n\n.productValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-xs);\n  color: var(--text-neutral-stronger);\n}\n\n.moreButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-1);\n  cursor: pointer;\n  border-radius: var(--radius-s);\n  color: var(--icon-neutral-stronger);\n  transition: background-color 0.2s ease;\n}\n\n.moreButton:hover {\n  background-color: var(--surface-neutral-subtle);\n}\n\n/* Feedback states */\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: var(--spacing-4);\n  text-align: center;\n}\n\n.loadingIconContent {\n  background: rgba(214, 64, 0, 0.1);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-3);\n}\n\n.errorIcon {\n  width: 72px;\n  height: 72px;\n  color: var(--icon-error-medium);\n  margin-bottom: var(--spacing-3);\n}\n\n.feedbackTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: 0;\n}\n\n.feedbackText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin-bottom: 0;\n}\n\n.feedbackButton {\n  margin-top: var(--spacing-3);\n}\n\n/* Empty state */\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  padding: var(--spacing-4);\n  text-align: center;\n}\n\n.emptyStateIcon {\n  width: 72px;\n  height: 72px;\n  color: var(--icon-neutral-stronger);\n  margin-bottom: var(--spacing-3);\n}\n\n.emptyStateTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: 0;\n}\n\n.emptyStateText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin-bottom: var(--spacing-3);\n  max-width: 300px;\n}\n\n.emptyStateButton {\n  margin-top: var(--spacing-1);\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .modalDialog {\n    max-width: 100vw;\n  }\n\n  .filtersContainer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .searchContainer {\n    min-width: auto;\n  }\n\n  .beneficiaryFooter {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-1);\n  }\n}\n\n/* New minimal beneficiary item styles */\n.beneficiaryItem {\n  padding: var(--spacing-3) 0;\n  border-bottom: 1px solid var(--bs-gray-200);\n  transition: background-color 0.2s ease;\n}\n\n.beneficiaryItem:hover {\n  background-color: var(--bs-gray-50);\n}\n\n.beneficiaryContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.beneficiaryMainInfo {\n  flex: 1;\n}\n\n.beneficiaryRole {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  margin: 0 0 var(--spacing-0-5) 0;\n}\n\n.beneficiaryId {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  margin: 0 0 0 var(--spacing-2);\n}\n\n.roleDivider {\n  display: inline-block;\n  width: 1px;\n  height: 8px;\n  margin-left: var(--spacing-1);\n  vertical-align: middle;\n  background-color: var(--stroke-neutral-subtle);\n}\n\n.cardStatusRow {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  margin-top: var(--spacing-0-5);\n}\n\n.cardIcon {\n  width: 20px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.cardStatusText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n}\n\n.cardIconNoIssued {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: var(--icon-neutral-medium);\n}\n\n.cardStatusTextNoIssued {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-medium);\n}\n\n/* Collaborators (emissor flow) — alinhado ao Figma usando tokens do design system.\n   Label/Medium semibold (14px) no nome; Label/Small regular (12px) nos detalhes;\n   texto escuro neutral[800], \"Não possui cartão\" neutral[600], gaps de 8px (spacing-1). */\n.collaboratorsList .beneficiaryItem {\n  padding: var(--spacing-2) 0;\n  border-bottom-color: var(--stroke-neutral-subtle);\n}\n\n.collaboratorsList .beneficiaryItem:hover {\n  background-color: transparent;\n}\n\n.collaboratorsList .beneficiaryName {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: normal;\n}\n\n.collaboratorsList .detailsTooltip img {\n  width: 12px;\n  height: 12px;\n}\n\n.collaboratorsList .beneficiaryRole {\n  margin-bottom: 0;\n  line-height: normal;\n  color: var(--text-neutral-dark);\n}\n\n.collaboratorsList .beneficiaryId {\n  margin-left: var(--spacing-1);\n  color: var(--text-neutral-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `tO0spE`,
	"modalDialog": `qgZoR5`,
	"modalContent": `j9OyGA`,
	"modalHeader": `ZqKxJi`,
	"modalTitle": `RTsvAE`,
	"backButton": `CxeNn1`,
	"modalBody": `CyGjUO`,
	"headerSection": `TjLU8z`,
	"summaryText": `A2_YXU`,
	"newEmployeesText": `oJjtxd`,
	"filtersCard": `AoRyIh`,
	"filtersContainer": `b3U9Rl`,
	"searchContainer": `AEbXvD`,
	"filterButton": `WrybZr`,
	"badge": `C4Q4ke`,
	"beneficiariesList": `_tQNH0`,
	"beneficiaryCard": `PGKDs3`,
	"beneficiaryHeader": `jdsaIZ`,
	"beneficiaryInfo": `Fqkk48`,
	"beneficiaryNameRow": `y5Acmy`,
	"beneficiaryName": `xw9EX_`,
	"detailsTooltip": `kIhI1A`,
	"beneficiaryDetails": `vLv_Kp`,
	"beneficiaryDetail": `FqvEUy`,
	"beneficiaryFooter": `hzjdHL`,
	"cardStatus": `pe2t1H`,
	"cardIssued": `h3yKZE`,
	"cardNotIssued": `t7jmQH`,
	"productValue": `ie2KvT`,
	"moreButton": `ZqUPh5`,
	"feedbackContainer": `b_HZYm`,
	"loadingIconContent": `AbVeOm`,
	"errorIcon": `Mo5Kji`,
	"feedbackTitle": `xp1HA4`,
	"feedbackText": `bAnoO4`,
	"feedbackButton": `oBMiRK`,
	"emptyState": `eIpzS8`,
	"emptyStateIcon": `Qzpvsf`,
	"emptyStateTitle": `gv0sya`,
	"emptyStateText": `nNEmk6`,
	"emptyStateButton": `m_I21B`,
	"beneficiaryItem": `Yf8kLO`,
	"beneficiaryContent": `RlFcrg`,
	"beneficiaryMainInfo": `zN6EBg`,
	"beneficiaryRole": `AtivFy`,
	"beneficiaryId": `VEnKHd`,
	"roleDivider": `uFVuRc`,
	"cardStatusRow": `p5ZBTa`,
	"cardIcon": `EpR4JR`,
	"cardStatusText": `mlIIFK`,
	"cardIconNoIssued": `iaTkd2`,
	"cardStatusTextNoIssued": `grkYTG`,
	"collaboratorsList": `lqn9tG`
};
module.exports = ___CSS_LOADER_EXPORT___;
